import { LocationDescriptorObject } from 'history';
import { Link } from 'react-router-dom';
import { Icon, IconVariant } from '../Icon/Icon';

type LinkDisplayProps = { icon: IconVariant; label: string };

const LinkDisplay = ({ icon, label }: LinkDisplayProps) => (
  <>
    <Icon className="w-100 h1 mb-1" variant={icon} height="25px" />
    <span className="w-100 display-5">{label}</span>
  </>
);

type Props = LinkDisplayProps & {
  index: number;
  internalUrl?: LocationDescriptorObject;
  externalUrl?: string;
  target?: string;
};

export const IconMenuItem = ({ label, icon, internalUrl, externalUrl, target, index }: Props) => {
  const className = index > 0 ? 'p-2 m-1 text-center' : 'text-center pl-0 ml-0 pr-2 pt-2 pb-2 mr-1 mt-1 mb-1';
  return externalUrl ? (
    <a className={className} href={externalUrl} target={target}>
      <LinkDisplay label={label} icon={icon} />
    </a>
  ) : (
    <Link className={className} to={internalUrl!}>
      <LinkDisplay label={label} icon={icon} />
    </Link>
  );
};
